import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';
import { ModalController, Platform, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { SIMPLEX_PRODUCT_KEY, SIMPLEX_URL } from 'src/app/angular-wallet-base/constants';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { getToastPosition, presentToast } from 'src/app/angular-wallet-base/utils';
declare var Simplex: any;
@Component({
    selector: 'simplex-checkout-modal',
    templateUrl: './simplex-checkout.html',
    styleUrls: ['./simplex-checkout.scss'],
})

export class SimplexCheckoutModalComponent implements OnInit, OnDestroy {
    isCheckoutLoading: boolean = false;
    public payment_id: string;
    public scriptElement:any;
    public isPaymentSuccess:boolean;
    public jsContainer:HTMLElement = this.elementRef.nativeElement;
    constructor(private modal: ModalController,
        private translate: TranslateService,
        private toast: ToastController,
        private platform: Platform,
        private elementRef:ElementRef
    ) {

    }
    ngOnDestroy(): void {
    }
   
    ngOnInit() {
        this.isCheckoutLoading = true;
        this.loadScript()
            .then(() => {
                this.startSimplex();
            })
            .catch(() => Logger.info("script not loaded"));
    }
    loadScript() {
        // loading simplex sdk script here based on dev/prod
        return new Promise(resolve => {
            this.scriptElement = document.createElement("script");
            this.scriptElement.src = SIMPLEX_URL;
            this.scriptElement.onload = resolve;
            this.jsContainer.appendChild(this.scriptElement);
        });
    }

    async startSimplex() {
        try {
            Simplex.init({ public_key: SIMPLEX_PRODUCT_KEY }, function (event) {
                Logger.warn(event) // => 'checkoutInitialised'
            })
        } catch (error) {
            console.error(error)
        }

        const params = {
            payment_id: this.payment_id
        }
        Simplex
            .load(params, (event) => {
                this.isCheckoutLoading = false;
                Logger.warn(event.type) // => 'checkoutLoadSucceeded'
            });
        Simplex.subscribe('checkoutLoadFailed', (event) => {
            Logger.info(event)
        });
        Simplex.subscribe('checkoutUnloaded', (event) => {
            Logger.info(event)
        });
        Simplex.subscribe('onlineFlowFinished', (event) => {
            Logger.info("onlineFlowFinished",event.payload)
            if (event.payload.result == "success") {
                this.isPaymentSuccess = true;
                this.cancelSimplex(true);
            } else {
                let msg = 'buy_lode.debitcard.messages.order_fail';
                let title = 'buy_lode.debitcard.messages.fail'
                presentToast(title, msg, this.translate, this.toast, this.platform);
                this.cancelSimplex(false);
            }
        });
    }

    cancelSimplex(status) {
        Simplex.unload({ public_key: SIMPLEX_PRODUCT_KEY });
        Simplex.unsubscribe('onlineFlowFinished', function (event) {
            Logger.info(event) // => "success" or "failure"
        });
        this.modal.dismiss(this.isPaymentSuccess? this.isPaymentSuccess:status, '', 'simplex-checkout-modal');
    }

}

